import { landmineNames } from '@mm/constants/landmine-names';
import { TriangleWarningIcon } from '@mm/icons';
import { useModalActions } from '@mm/state/modules/modalsState/actions';
import { activeFacebookPageSelector } from '@mm/state/selectors/facebookPageSelector';
import { combinedFeatureFlagsSelector } from '@mm/state/selectors/featureFlagsSelectors';
import React from 'react';
import { useSelector } from 'react-redux';
import { PrimaryButton } from '../../../../../../common/buttons/PrimaryButton/PrimaryButton';
import styles from './NoEmailAccountsWarning.module.css';

export const NoEmailAccountsWarning = () => {
  const facebookPage = useSelector(activeFacebookPageSelector);
  const isEmailActivated = !!facebookPage?.emailActivated;
  const hasNativeIntegrationsFeature = useSelector(
    combinedFeatureFlagsSelector,
  ).nativeIntegrations;

  const { openUniversalUpgradeLandmineModal, openActivateEmailAccountModal } =
    useModalActions();

  if (isEmailActivated) {
    return null;
  }

  const onConnectAccountClick = () => {
    if (!hasNativeIntegrationsFeature) {
      openUniversalUpgradeLandmineModal({
        landmineName: landmineNames.AUTOMATION_SEND_SOLD_EMAIL,
        feature: 'nativeIntegrations',
        onSuccessBilling: openActivateEmailAccountModal,
      });
    } else {
      openActivateEmailAccountModal();
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.left}>
        <TriangleWarningIcon />
        <div className={styles.titleBlock}>
          <div className={styles.bold500}>No email accounts connected</div>
          <div className={styles.textSmall}>
            In order to contact your leads you must connect your email{' '}
          </div>
        </div>
      </div>
      <PrimaryButton
        className={styles.primaryButton}
        onClick={onConnectAccountClick}
      >
        Connect email account
      </PrimaryButton>
    </div>
  );
};
